import { PROVIDER } from '../../figure/constants';

const getFormattedVideos = videos => (videos || []).map(video => ({ ...video, provider: PROVIDER.YOUTUBE }));

export default getFormattedVideos;
